(() => {
  async function removeGift(button) {
    const group = button.closest('[data-tgc-gift-group]');
    const keys = String(button.dataset.tgcGiftKeys || '')
      .split('|')
      .map((key) => decodeURIComponent(key))
      .filter(Boolean);
    if (!keys.length) return;

    group?.classList.add('is-removing');
    button.disabled = true;
    button.textContent = 'Removing…';
    const updates = Object.fromEntries(keys.map((key) => [key, 0]));

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
      if (!response.ok) throw new Error('Cart update failed');
      window.location.reload();
    } catch (error) {
      group?.classList.remove('is-removing');
      button.disabled = false;
      button.textContent = 'Remove gift';
      window.alert('We could not remove the complete gift. Please refresh and try again.');
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-tgc-remove-gift]');
    if (button) removeGift(button);
  });
})();
